import ILoginForm from '@/interfaces/ILoginForm';
import IState from '@/interfaces/IState';
// import getCookieDomain from '@/libs/domain/getCookieDomain';
import router from '@/router';
// import Cookies from 'js-cookie';
import { ActionContext } from 'vuex';

export default async (context: ActionContext<IState, IState>, authData: ILoginForm) => {
    if (!authData) {
        return Promise.reject('Incorrect form data');
    }
    try {
        const login = await context.dispatch('backendTalker', {
            request: 'sign_in',
            data: authData
        });
        if (!login) {
            return Promise.reject('Permission denied');
        } else if (login.status === 200) {
            const authToken = `Bearer ${login.data.token}`
    
            context.commit('authUser', authToken);
            
            // Cookies.set('access_token', authToken, {
            //     expires: 30, // Create a cookie that expires 30 days from now, valid across the entire site.
            //     domain: getCookieDomain()
            // });

            localStorage.setItem('access_token', authToken);
            router.push('/')
        } else {
            return login.data;
        }
    } catch (err) {
        return Promise.reject(err);
    }
};
